// istanbul ignore file
// Covered in browser test (test-app/browser-tests/tests/blueButtonsExperiment.cy.ts)
import React, { FC } from 'react'
import { ThemeProvider } from '@moonpig/launchpad-utils'
import { theme, blueButtonTheme } from '@moonpig/launchpad-theme'
import { useExperimentBoolean } from '@moonpig/web-core-eppo/browser'

export const ThemeWrapper: FC<React.PropsWithChildren> = ({ children }) => {
  const isBlueButtonExperiment = useExperimentBoolean('blue-buttons', {
    fallback: false,
  })

  return (
    <ThemeProvider theme={isBlueButtonExperiment ? blueButtonTheme : theme}>
      {children}
    </ThemeProvider>
  )
}
